import { useEffect } from "react";
import { unlockAudio, playAppOpenOnce } from "../lib/sound";

// Sblocca l'AudioContext al primo gesto utente (policy autoplay) e riproduce il suono
// di apertura una sola volta per sessione.
export default function SoundBootstrap() {
  useEffect(() => {
    const onGesture = () => {
      unlockAudio();
      playAppOpenOnce();
      window.removeEventListener("pointerdown", onGesture);
      window.removeEventListener("keydown", onGesture);
    };
    window.addEventListener("pointerdown", onGesture, { once: false });
    window.addEventListener("keydown", onGesture, { once: false });
    return () => {
      window.removeEventListener("pointerdown", onGesture);
      window.removeEventListener("keydown", onGesture);
    };
  }, []);
  return null;
}
